import React, { memo, ReactNode } from 'react';
import { Box, BoxProps } from '@mui/material';

import Footer from '../../../../components/Shared/Footer';

export interface IRecipientActionWrapperProps {
  titleContent: ReactNode | null;
  children: ReactNode;
  titleWrapperProps?: BoxProps;
  childrenWrapperProps?: BoxProps;
}

const RecipientActionWrapper = ({
  titleContent,
  children,
  titleWrapperProps = {},
  childrenWrapperProps = {},
}: IRecipientActionWrapperProps): JSX.Element => (
  <Box width={1} height={1} display="flex" flexDirection="column" alignItems="center">
    {titleContent && (
      <Box
        className="actionWrapper-ie"
        width={1}
        minHeight={[120, 170]}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        p={2}
        {...titleWrapperProps}
      >
        {titleContent}
      </Box>
    )}
    <Box
      className="childrenWrapper-ie"
      height={1}
      width={1}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" {...childrenWrapperProps}>
        {children}
      </Box>
      <Footer mobileHidden />
    </Box>
  </Box>
);

export default memo<IRecipientActionWrapperProps>(RecipientActionWrapper);
